import { sortRoles, type RoleRef } from '@dawn/feature-config';

/**
 * One pill per role, Super Admin → Admin → Analyst whatever order the server
 * sends (TDEV-1213 step 08). An empty set (a legacy role-less invitation) shows a
 * muted dash. Reuses the markup of the "Primary Admin" badge it replaces.
 */
export function RoleChips({ roles, testId }: { roles: RoleRef[]; testId?: string }) {
  if (roles.length === 0) {
    return (
      <span className="text-muted-foreground" data-testid={testId}>
        —
      </span>
    );
  }
  return (
    <div className="flex flex-wrap gap-1" data-testid={testId}>
      {sortRoles(roles).map((role) => (
        <span
          key={role.id}
          className="inline-flex items-center whitespace-nowrap rounded-full bg-primary/10 px-2.5 py-0.5 text-xs font-medium text-primary"
        >
          {role.name}
        </span>
      ))}
    </div>
  );
}
